import { Phone } from "lucide-react";
import { COMPANY } from "../constants/data";

export const MobileCallButton = () => (
  <a
    href={COMPANY.phoneHref}
    className="lg:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-primary text-white font-bold uppercase tracking-wide text-sm px-5 py-3.5 shadow-lg shadow-black/40 rounded-full"
    data-testid="mobile-call-button"
  >
    <Phone className="w-4 h-4" /> Appeler
  </a>
);
